import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "panel-result" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_CatalogueGrid = _resolveComponent("CatalogueGrid")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_CatalogueGrid, {
      controller: 'PlanPackageResult',
      customLoadUrl: "GetDetailedRollupData",
      customParentId: _ctx.parentModel.idParent,
      customParams: _ctx.customParams,
      toolbarItems: _ctx.toolbarItems,
      columns: _ctx.columns,
      filterRowVisible: true,
      groupPanelVisible: false,
      headerFilterVisible: !_ctx.selectMode,
      filterPanelVisible: false,
      showPageSizeSelector: !_ctx.selectMode,
      pageSize: 10,
      pageSizes: _ctx.pageSizes,
      editingConfig: _ctx.editingConfig,
      selectionConfig: _ctx.selectionConfig,
      designConfig: _ctx.designConfig,
      getSelectedData: _ctx.getSelectedData,
      changeSelectedData: _ctx.changeSelectedData,
      parentModel: _ctx.parentModel,
      selectMode: _ctx.selectMode,
      onInsertedCallback: _ctx.refreshParent,
      onUpdatedCallback: _ctx.refreshParent,
      onRowRemovedCallback: _ctx.refreshParent,
      onRowPrepared: _ctx.onRowPrepared,
      class: "detailedRollupGrid"
    }, null, 8, ["customParentId", "customParams", "toolbarItems", "columns", "headerFilterVisible", "showPageSizeSelector", "pageSizes", "editingConfig", "selectionConfig", "designConfig", "getSelectedData", "changeSelectedData", "parentModel", "selectMode", "onInsertedCallback", "onUpdatedCallback", "onRowRemovedCallback", "onRowPrepared"])
  ]))
}